import { TermsPolicyComponent } from '../components/layout/terms-policy/terms-policy.component';
import { TermsConditionsComponent } from '../components/layout/terms-conditions/terms-conditions.component';
import { Routes } from '@angular/router';

export const staticRoutes: Routes = [
  {
    path: 'politicas-privacidad',
    component: TermsPolicyComponent,
  },
  {
    path: 'condiciones-de-uso',
    component: TermsConditionsComponent,
  },
];
